'use client'
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/currency/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getCurrencies = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getCurrencies($lang: String, $limit: Int, $skip: Int, $where: CurrencyFilter) {
          currencyCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {
              id
              title
              symbol
              code
            }
          }
        }
      `,
      __spreadValues({ order: "order_ASC" }, props)
    );
    return res.currencyCollection.items;
  } catch (error) {
    throw new Exception({ error, name: "getCurrenciesException" });
  }
});
var useGetCurrencies = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getCurrencies", props],
    queryFn: () => getCurrencies(props)
  }, options));
};

export {
  useGetCurrencies
};
//# sourceMappingURL=chunk-GXJBDGFN.mjs.map